export class Credentials {
  username: string;
  password: string;
  repeatPassword: string;
  privacyPolicyAccepted: boolean;
}